module.exports = __webpack_public_path__ + "assets/img/footLogo.b8d9ead0.png";